import Fuse from 'fuse.js';
import { DietType, MedusaProductVariant } from 'lib/home/generated/types/api';
import { Filter } from '../Filters';
import { mealPreferencesIconMap } from '../Forms/PreferencesForm/PreferencesForm.helpers';

export const mealsFilterOptionGroups = [
  {
    name: 'category',
    options: [
      {
        name: 'favorites',
        value: 'favorites',
        label: 'Favorites',
        icon: 'heart'
      },
      {
        name: 'premium',
        value: 'premium',
        label: 'Premium',
        icon: 'premium'
      },
      {
        name: 'diet',
        label: 'Vegan',
        value: DietType.Vegan,
        icon: mealPreferencesIconMap[DietType.Vegan]
      },
      {
        name: 'diet',
        label: 'Vegetarian',
        value: DietType.Vegetarian,
        icon: mealPreferencesIconMap[DietType.Vegetarian]
      },
      {
        name: 'diet',
        label: 'Pescatarian',
        value: DietType.Pescatarian,
        icon: mealPreferencesIconMap[DietType.Pescatarian]
      },
      {
        name: 'diet',
        label: 'No Red Meat',
        value: DietType.NoRedMeat,
        icon: mealPreferencesIconMap[DietType.NoRedMeat]
      },
      {
        name: 'diet',
        label: 'Low Carb',
        value: DietType.LowCarb,
        icon: mealPreferencesIconMap[DietType.LowCarb]
      },
      {
        name: 'diet',
        label: 'Gluten Free',
        value: DietType.GlutenFree,
        icon: mealPreferencesIconMap[DietType.GlutenFree]
      },
      {
        name: 'diet',
        label: 'Dairy Free',
        value: DietType.DairyFree,
        icon: mealPreferencesIconMap[DietType.DairyFree]
      },
      {
        name: 'diet',
        label: 'Non-Spicy',
        value: DietType.NonSpicy,
        icon: mealPreferencesIconMap[DietType.NonSpicy]
      }
    ]
  }
];

const applyMealsSearch = (meals: MedusaProductVariant[], filters: Filter[]) => {
  // Return early if no filters are set
  if (!filters.length) return meals;

  const searchFilter = filters.find(filter => filter.name === 'search');

  // Return early if no search query has been entered or if the search query is less than 3 characters
  if (!searchFilter || searchFilter.value.length < 3) return meals;

  const fuse = new Fuse(meals, {
    minMatchCharLength: 3,
    threshold: 0.3,
    includeScore: true,
    keys: [
      {
        name: 'title',
        weight: 2
      },
      // QUESTION: Wondering if we should not search against diets here, since we have the diet filters for that.
      // Also, if someone types in "red meat," it will return meals that have been marked "no red meat."
      {
        name: 'dietary_information.diets',
        weight: 0.3
      },
      {
        name: 'dietary_information.ingredients',
        weight: 0.3
      }
    ]
  });

  const results = fuse.search(searchFilter?.value || '');

  // Note: filter out results that don't meet our score threshold before returning the results
  return results.filter(result => result.score < 0.4).map(({ item }) => item);
};

export const applyMealsFilters = (meals: MedusaProductVariant[], filters: Filter[]) => {
  // Return early if there are no meals
  if (!meals.length) return meals;

  // Return early if no filters are set
  if (!filters.length) return meals;

  const dietFilters = filters.filter(filter => filter.name === 'diet');
  const favoriteFilter = filters.find(filter => filter.name === 'favorites');
  const premiumFilter = filters.find(filter => filter.name === 'premium');

  const results = applyMealsSearch(meals, filters);

  const filteredResults = results.filter(item => {
    let matchesDietFilters = true;
    let matchesFavoriteFilter = true;
    let matchesPremiumFilter = true;

    // Check if the variant matches the diet filters
    if (dietFilters.length) {
      // Inclusive filtering
      // matchesDietFilters = item.dietary_information.diets.some(diet =>
      //   dietFilters.find(filter => filter.value === diet)
      // );

      // Exclusive filtering
      matchesDietFilters = dietFilters.every(diet => item.dietary_information.diets.includes(diet.value as DietType));
    }

    // Check if the variant is a favorite
    if (favoriteFilter && !item.variant_preference?.favorite) {
      matchesFavoriteFilter = false;
    }

    if (premiumFilter && !item.metadata.premium_upcharge) matchesPremiumFilter = false;

    return matchesDietFilters && matchesFavoriteFilter && matchesPremiumFilter;
  });

  return filteredResults;
};
